// extracted by mini-css-extract-plugin
module.exports = {"block":"SearchMobile_block__qHW76"};